const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getEventRange = (eventLike = {}) => {
  const eventStart = toDate(eventLike?.startDate);
  const eventEnd = toDate(eventLike?.endDate);
  return { eventStart, eventEnd };
};

export const doesWorkOrderNeedAlignment = (workOrder, eventStart, eventEnd) => {
  const startedAt = toDate(workOrder?.startedAt);
  const completedAt = toDate(workOrder?.completedAt);

  const startsBeforeEvent = Boolean(eventStart && startedAt && startedAt < eventStart);
  const endsAfterEvent = Boolean(eventEnd && completedAt && completedAt > eventEnd);

  return startsBeforeEvent || endsAfterEvent;
};

export const hasWorkOrdersOutsideEventRange = (workOrders = [], eventStart, eventEnd) =>
  Array.isArray(workOrders)
    && workOrders.some((workOrder) => doesWorkOrderNeedAlignment(workOrder, eventStart, eventEnd));

export const buildAlignmentPayload = (workOrder, eventStart, eventEnd) => {
  const payload = {};
  const startedAt = toDate(workOrder?.startedAt);
  const completedAt = toDate(workOrder?.completedAt);

  if (eventStart && startedAt && startedAt < eventStart) {
    payload.startedAt = eventStart.toISOString();
  }

  if (eventEnd && completedAt && completedAt > eventEnd) {
    payload.completedAt = eventEnd.toISOString();
  }

  return payload;
};

export const buildCompleteWorkOrderPayload = (workOrder, completeStatusId, eventStart, eventEnd, alignDates) => {
  const payload = { statusId: completeStatusId };

  if (!alignDates) {
    return payload;
  }

  return { ...payload, ...buildAlignmentPayload(workOrder, eventStart, eventEnd) };
};

export const areWorkOrdersCompletableForEvent = (workOrders = [], eventStart, eventEnd) => {
  if (!Array.isArray(workOrders)) return false;
  if (!eventStart || !eventEnd) return false;

  return workOrders.every((workOrder) => {
    const statusId = Number(workOrder?.statusId);
    if (![4, 5].includes(statusId)) {
      return false;
    }

    const startedAt = toDate(workOrder?.startedAt);
    const completedAt = toDate(workOrder?.completedAt);

    if (eventStart && startedAt && startedAt < eventStart) {
      return false;
    }

    if (eventEnd && completedAt && completedAt > eventEnd) {
      return false;
    }

    return true;
  });
};
